import { Controller } from '@hotwired/stimulus'

// When a session filter is active, intercepts broadcast check-in stat updates
// (which contain all-sessions data) and re-fetches with the selected session.
//
// In check-in mode (persist=true), the selected session is saved to sessionStorage
// so it survives page navigations within the same tab and clears on tab close.
export default class extends Controller {
  static values = { eventId: Number, persist: Boolean }

  get storageKey() {
    return `check_in_session_${this.eventIdValue}`
  }

  connect() {
    this.boundIntercept = this.interceptStream.bind(this)
    document.addEventListener('turbo:before-stream-render', this.boundIntercept)

    if (this.persistValue) {
      const referrerPath = document.referrer && new URL(document.referrer, window.location.origin).pathname
      if (referrerPath?.includes('/check_ins')) {
        this.restoreFilter()
      } else {
        sessionStorage.removeItem(this.storageKey)
        this.#revealStats()
      }
    } else {
      this.#revealStats()
    }
  }

  disconnect() {
    document.removeEventListener(
      'turbo:before-stream-render',
      this.boundIntercept,
    )
  }

  saveFilter() {
    if (!this.persistValue) return

    const select = this.element.querySelector('select.session-filter-select')
    if (select) sessionStorage.setItem(this.storageKey, select.value)
  }

  interceptStream(event) {
    const form = document.querySelector('form.session-filter')
    const stream = event.detail?.newStream || event.target

    // If a specific session is selected and the broadcast is replacing the check-in stats,
    // cancel the broadcast (which has all-sessions data) and re-fetch with the current session.
    if (
      form?.querySelector('select')?.value &&
      stream?.getAttribute('target')?.includes('check_in_data')
    ) {
      event.preventDefault()
      form.requestSubmit()
    }
  }

  restoreFilter() {
    const saved = sessionStorage.getItem(this.storageKey)
    const statsFrame = this.element.querySelector('turbo-frame#check-in-stats')

    if (!saved) {
      statsFrame?.removeAttribute('data-loading')
      return
    }

    const select = this.element.querySelector('select.session-filter-select')
    if (select && select.value !== saved) {
      select.value = saved
      statsFrame?.addEventListener('turbo:frame-load', () => statsFrame.removeAttribute('data-loading'), { once: true })
      this.element.querySelector('form.session-filter')?.requestSubmit()
    } else {
      statsFrame?.removeAttribute('data-loading')
    }
  }

  #revealStats() {
    this.element.querySelector('turbo-frame#check-in-stats')?.removeAttribute('data-loading')
  }
}
